// Spec: <div data-lr-embed-quiz></div>

class EmbeddedQuiz {
  el: HTMLElement;

  constructor(el: HTMLElement) {
    this.el = el;
    this.render();
  }

  async render() {
    this.el.innerHTML = `
      <section class="flex--row flex--mobile--column plant-finder-banner--blog">
        <img src="//www.livelyroot.com/cdn/shop/files/plant-finder-banner-aside.jpg?v=1709628998&width=100"
          alt="Plant in a pot in an outdoor setting next to some furniture"
          data-srcset="//www.livelyroot.com/cdn/shop/files/plant-finder-banner-aside.jpg?v=1709628998&width=300 300w, //www.livelyroot.com/cdn/shop/files/plant-finder-banner-aside.jpg?v=1709628998&width=500 500w, //www.livelyroot.com/cdn/shop/files/plant-finder-banner-aside.jpg?v=1709628998&width=730 730w"
          width="500" height="624" loading="lazy" class="blur-up lazyload" data-sizes="auto" />
        <div class="plant-finder-banner-blog__content">
          <h3>Find Your Plant Match</h3>
          <div class="plant-finder-banner__desc">Get a Personalized Plant Recommendation</div>
          <div>
            <a href="/pages/plant-quiz" class="lr-btn lr-btn--green" title="Lively Root Plant Finder">Take the Quiz ></a>
          </div>
        </div>
      </section>
    `;
  }
}

export default EmbeddedQuiz;
